module.exports = __webpack_public_path__ + "static/media/box3.9021b414.jpeg";